$(function() {
	
	// Main navigation code
/*	$('html, body').on('click', function(e) {
		var dd = $('.nav-dropdown:visible');
		
		if (! dd.has( $(e.target) ).length) dd.slideUp();
	});

	
	$('#main-nav .main-nav .nav').each(function() {
		var nav = $(this),
			anchors = $('.nav-item'),
			dropdowns = $('.nav-dropdown');

				
		anchors.hover(function() {
			var a = $(this),
				dd = a.find('> .nav-dropdown'),
				arrows = $('.nav-arrow-up');
			
			//var x = a.offset().left + (a.outerWidth()/2) - 10;
			var x = ((dd.outerWidth()/2) - 30)* (-1);
			
			if (! $('.nav-dropdown:visible').length) {
				dd.slideDown();
			} else {
				dropdowns.hide();
				dd.show();
			}
			
			//dd.find('.sub-nav-item').removeClass('active').first().addClass('active');
			//dd.find('.sub-img-item').hide().first().show();

			dd.css('left', x);
			
			//arrows.css('left', x);
		});
		
	});*/

$(".nav-item.has-dropdown").mouseenter(function(){
    clearTimeout($(this).data('timeoutId'));
    $(this).find(".nav-dropdown").fadeIn("slow");
}).mouseleave(function(){
    var someElement = $(this),
        timeoutId = setTimeout(function(){
            someElement.find(".nav-dropdown").fadeOut("fast");
        }, 50);
    //set the timeoutId, allowing us to clear this trigger if the mouse comes back over
    someElement.data('timeoutId', timeoutId); 
});

	
	// Subnavigation code
	/*$('.nav-dropdown').each(function() {
		var dd = $(this),
			subnav = $('.sub-nav', dd),
			anchors = $('.sub-nav-item a'),
			images = $('.sub-img-item', dd);
		
		anchors.hover(function(e) {
			var a = $(this),
				id = a.attr('data-img');
			
			images.hide();
			anchors.parent('li').removeClass('active');

			$('#'+id).show();
			a.parent('li').addClass('active');
		});
	});*/
	
});